export const commonPagesConstants = {
  SET_COMMON_PAGES: 'SET_COMMON_PAGES',
};
